import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CONSUMER_TIMELINE_VIEW_ENDPOINT } from "../../constants/routes";
import useNetwork from "../../hooks/useNetwork";
import LeaseWrapper from "../proposal/lease/LeaseWrapper";
import DetailsHolder from "../proposal/proposalDetails/DetailsHolder";

const TimelinePurchaseDetails = () => {
    const { proposalId } = useParams();
    const [proposal] = useState(proposalId);
    const [lease, setLease] = useState(null);

    const { data, error, loading } = useNetwork(
        `${CONSUMER_TIMELINE_VIEW_ENDPOINT}/purchase/${proposal}`
    );
    useEffect(() => {
        if (data) setLease(data?.data?.data);
    }, [data]);

    return (
        <div>
            <DetailsHolder>
                <LeaseWrapper lease={lease} loading={loading} error={error} />
            </DetailsHolder>
        </div>
    );
};

export default TimelinePurchaseDetails;
